export function resizeIframe(trelloIframe: any, classNameSelector: string) {
  const height = document.querySelector(classNameSelector)?.scrollHeight;
  if (height) {
    trelloIframe.sizeTo(height);
  }
}
